<section class="w-full relative">
  <!-- loader -->
  <div class="h-[calc(100vh-114px)] mt-2 justify-center items-center flex" *ngIf="isLoading">
    <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500 !important"></div>
  </div>
  <!-- chart section -->
  <div class="w-full flex flex-col mr-2" *ngIf="!isLoading">
    <div class="mt-2 grid h-fit w-full grid-cols-4 gap-2">
      <div class="bg-white">
        <a routerLink="/dashboard/configuration/practices" [queryParams]="{filter: 'all'}"
          class="flex items-center gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32H288V368c0-17.7 14.3-32 32-32H480V224c0-17.7-14.3-32-32-32H320V64c0-17.7-14.3-32-32-32H32zM128 96h64v64H128V96zm0 128h64v64H128V224zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm288-96h64v64H384V256zM544 256c17.7 0 32 14.3 32 32V480H352V288c0-17.7 14.3-32 32-32H544z" />
          </svg>
          {{ dashboardData ? dashboardData.totalPracticeCount : 0 }} Total Practices</a>
      </div>
      <div class="bg-white">
        <a routerLink="/dashboard/configuration/practices"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 576 512">
            <path
              d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
          </svg>
          {{ dashboardData ? dashboardData.totalActivePracticeCount : 0 }} Active Practices</a>
      </div>
      <div class="bg-white">
        <a routerLink="/dashboard/configuration/practices" [queryParams]="{filter: 'installed-practices'}"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 576 512">
            <path
              d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
          </svg>
          {{ dashboardData ? dashboardData.installedPracticeCount : 0 }} Installed Practices</a>
      </div>
      <div class="bg-white">
        <a [routerLink]="['/dashboard/configuration/practices']" [queryParams]="{filter: 'pending-installation'}"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 576 512">
            <path
              d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
          </svg>
          {{ dashboardData ? dashboardData.installedPendingPracticeCount : 0 }} Pending Installations</a>
      </div>
      <div class="bg-white">
        <a [routerLink]="['/dashboard/configuration/practices']" [queryParams]="{filter: 'go-live'}"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 576 512">
            <path
              d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
          </svg>
          {{ dashboardData ? dashboardData.livePracticeCount : 0 }} Live Practices</a>
      </div>
      <div class="bg-white">
        <a [routerLink]="['/dashboard/configuration/practices']" [queryParams]="{filter: 'disabled'}"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 576 512">
            <path
              d="M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z" />
          </svg>
          {{ dashboardData ? dashboardData.totalDisabledPracticeCount : 0 }} Disabled Practices</a>
      </div>
      <div class="bg-white">
        <a [routerLink]="['/dashboard/configuration/pms']" [queryParams]="{filter: 'active'}"
          class="flex gap-3 cursor-pointer hover:text-indigo-500 focus:text-indigo-500 p-5"><svg
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 512 512">
            <path
              d="M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z" />
          </svg>
          {{ dashboardData ? dashboardData.pmsCount : 0 }} Active PMS</a>
      </div>
      <div class="bg-white">
        <a [ngClass]="{
            'cursor-default': !(getUserRole() === 'SUPER ADMIN'),
            'cursor-pointer hover:text-indigo-500 focus:text-indigo-500':
              getUserRole() === 'SUPER ADMIN'
          }" [routerLink]="
            getUserRole() === 'SUPER ADMIN'
              ? ['/dashboard/user-role-management']
              : null
          " [queryParams]="{filter: 'active'}" class="flex gap-3 p-5">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="currentColor" viewBox="0 0 640 512">
            <path
              d="M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z" />
          </svg>
          {{ dashboardData ? dashboardData.usersCount : 0 }} Active Users</a>
      </div>

    </div>

    <!-- data load status  -->
    <div class="bg-white h-fit w-full mt-2 flex items-center mr-2 relative">
      <!-- Chart taking 95% width -->
      <div class="flex-[0.90]">
        <app-chart [chartConfig]="{
            title: '',
            type: 'Bar',
            is3D: true,
            height: 350,
            isStacked: true,
            legend: { position: 'top' },
            colors: ['#FFA500','#4CAF50','#2196F3', '#673AB7', '#D32F2F', '#9E9E9E', '#FF5722'],
            vAxis: { title: 'No. of Loads' },
            hAxis: { title: 'Last 7 Days Load Status (6 PM To 8 AM EST)' }
          }" [data]="dataLoadStatus" (onChartClick)="handleChartClick($event)" (onhideChart)="hideChart()">
        </app-chart>
      </div>
    </div>

    <!-- grid -->
    <div class="bg-white mt-2" *ngIf="showLoadDetails">
      <div class="w-full h-full absolute bg-white opacity-50 flex items-center justify-center z-50"
        *ngIf="isDataLoadSummaryLoading">
        <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500"></div>
      </div>

      <!-- Custom grid with ellipses menu -->
      <div class="p-4">
        <!-- Header with controls -->
        <div class="flex justify-between items-center mb-4">
          <div class="flex items-center gap-3">
            <h3 class="text-base font-semibold">
              Practice Load Summary
              <span *ngIf="selectedChartDate" class="text-gray-500 ml-2">({{ selectedChartDate }})</span>
            </h3>
            <span class="inline-flex items-center gap-1.5 px-2 py-0.5 text-xs regular-font text-red-700 bg-red-100 border border-red-300">
              <span class="inline-block w-2.5 h-2.5 rounded-full bg-red-400"></span>
              Unhealthy Practice
            </span>
          </div>
          <div class="flex gap-2">
            <!-- Refresh Button -->
            <button type="button" (click)="handleChartClick(selectedChartDate)"
              class="inline-flex items-center gap-2 px-3 py-1.5 bg-indigo-500 hover:bg-indigo-400 text-white focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-indigo-500 regular-font transition-colors duration-200">
              <svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="0 0 512 512" fill="currentColor">
                <path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"/>
              </svg>
              Refresh
            </button>

            <!-- Column selector -->
            <div class="dashboard-dropdown" appClickOutsideDirective (appClickOutside)="closeHeaderDropdowns()">
              <div class="relative" (click)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
                <button type="button"
                  class="inline-flex items-center px-3 py-1.5 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 regular-font"
                  (click)="toggleColumnSelector($event)">
                  <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16">
                    </path>
                  </svg>
                  <span>Select Columns</span>
                  <svg class="-mr-1 ml-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clip-rule="evenodd" />
                  </svg>
                </button>

                <div class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-sm shadow-lg z-10"
                  [ngClass]="{ hidden: !isColumnSelectorOpen }" (click)="$event.stopPropagation()"
                  (pointerdown)="$event.stopPropagation()">
                  <div class="py-1 max-h-64 overflow-auto">
                    <div class="px-4 py-2 hover:bg-gray-100" *ngFor="let column of dataLoadSummaryColumns">
                      <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                          [checked]="isColumnVisible(column.jsonKey)"
                          (change)="toggleColumnVisibility(column.jsonKey)" />
                        <span class="ml-2 regular-font text-gray-700">{{ column.name }}</span>
                      </label>
                    </div>
                  </div>
                  <div class="border-t border-gray-200 px-2 py-1">
                    <button type="button"
                      class="w-full inline-flex justify-center items-center px-3 py-1.5 text-white bg-indigo-500 hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 regular-font disabled:opacity-50 disabled:cursor-not-allowed"
                      (click)="onSavePreferences($event)" [disabled]="isSavingPreferences">
                      <div class="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"
                        *ngIf="isSavingPreferences"></div>
                      <span>{{ isSavingPreferences ? 'Saving...' : 'Save Preferences' }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Export Button with Dropdown -->
            <div class="dashboard-dropdown" appClickOutsideDirective (appClickOutside)="closeHeaderDropdowns()">
              <div class="relative" (click)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
                <button
                  class="inline-flex items-center ring-offset-1 text-white bg-indigo-500 ring-gray-300 focus:outline-none hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5"
                  (click)="toggleDropdown($event)">
                  <span class="mr-1">Export</span>
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 20 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>

                <div class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-sm shadow-lg z-10"
                  [ngClass]="{ hidden: !isDropdownOpen }" (click)="$event.stopPropagation()"
                  (pointerdown)="$event.stopPropagation()">
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                    (click)="exportData(); isDropdownOpen = false">
                    Export to Excel
                  </a>
                  <div class="border-t border-gray-200"></div>
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer"
                    (click)="exportDataToPDF('Dashboard Load Summary', 'Current'); isDropdownOpen = false">
                    Export to PDF
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto" style="overflow: visible;">
          <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" class="w-full"
            style="overflow: visible;">

            <!-- Practice Code Column -->
            <ng-container matColumnDef="practiceCode" *ngIf="isColumnVisible('practiceCode')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Practice Code
              </th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.practiceCode}}
              </td>
            </ng-container>

            <!-- Live Column -->
            <ng-container matColumnDef="isLive" *ngIf="isColumnVisible('isLive')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Live</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.isLive}}</td>
            </ng-container>

            <!-- Ready For Base Column -->
            <ng-container matColumnDef="transformStatus" *ngIf="isColumnVisible('transformStatus')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Ready For Base
              </th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.transformStatus}}
              </td>
            </ng-container>

            <!-- Hyper-V Column -->
            <ng-container matColumnDef="isHyperV" *ngIf="isColumnVisible('isHyperV')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Hyper-V</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.isHyperV}}</td>
            </ng-container>

            <!-- Last Reported Healthcheck Column -->
            <ng-container matColumnDef="lastReportedHealthCheck" *ngIf="isColumnVisible('lastReportedHealthCheck')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Last Reported
                Healthcheck (EST)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">
                {{element.lastReportedHealthCheck | date:'yyyy-MM-dd HH:mm:ss'}}</td>
            </ng-container>

            <!-- Download Speed Column -->
            <ng-container matColumnDef="internetDownloadSpeed" *ngIf="isColumnVisible('internetDownloadSpeed')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Download Speed
                (Mbps)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">
                {{element.internetDownloadSpeed}}</td>
            </ng-container>

            <!-- Upload Speed Column -->
            <ng-container matColumnDef="internetUploadSpeed" *ngIf="isColumnVisible('internetUploadSpeed')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Upload Speed
                (Mbps)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">
                {{element.internetUploadSpeed}}</td>
            </ng-container>

            <!-- PMS Column -->
            <ng-container matColumnDef="pms" *ngIf="isColumnVisible('pms')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">PMS</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.pms}}</td>
            </ng-container>

            <!-- PMS Version Updated Column -->
            <ng-container matColumnDef="versionUpdated" *ngIf="isColumnVisible('versionUpdated')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">PMS Version
                Updated?</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.versionUpdated}}
              </td>
            </ng-container>

            <!-- PMS Agent Version Column -->
            <ng-container matColumnDef="pmsAgentVersion" *ngIf="isColumnVisible('pmsAgentVersion')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">PMS Agent
                Version</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.pmsAgentVersion}}
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status" *ngIf="isColumnVisible('status')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm regular-font">Status</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm regular-font">{{element.status}}</td>
            </ng-container>

            <!-- Load Type Column -->
            <ng-container matColumnDef="loadTypeName" *ngIf="isColumnVisible('loadTypeName')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">Load Type</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.loadTypeName}}</td>
            </ng-container>

            <!-- Start Time Column -->
            <ng-container matColumnDef="startTime" *ngIf="isColumnVisible('startTime')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">Start Time (EST)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.startTime | date:'yyyy-MM-dd
                HH:mm:ss'}}</td>
            </ng-container>

            <!-- End Time Column -->
            <ng-container matColumnDef="endTime" *ngIf="isColumnVisible('endTime')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">End Time (EST)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.endTime | date:'yyyy-MM-dd
                HH:mm:ss'}}</td>
            </ng-container>

            <!-- Duration Column -->
            <ng-container matColumnDef="duration" *ngIf="isColumnVisible('duration')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">Duration (mins)</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.duration}}</td>
            </ng-container>

            <!-- Estimate Load Time Column -->
            <ng-container matColumnDef="estimatedLoadTime" *ngIf="isColumnVisible('estimatedLoadTime')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-center text-sm">Estimate Load Time (mins)
              </th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm text-center">{{element.estimatedLoadTime}}
              </td>
            </ng-container>

            <!-- Load Elapsed Time Column -->
            <ng-container matColumnDef="elapsedLoadTime" *ngIf="isColumnVisible('elapsedLoadTime')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-center text-sm">Elapsed Load Time (mins)
              </th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm text-center">{{element.elapsedLoadTime}}
              </td>
            </ng-container>

            <!-- Practice Notes Column -->
            <ng-container matColumnDef="notes" *ngIf="isColumnVisible('notes')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">Practice Notes</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.notes}}</td>
            </ng-container>

            <!-- Error Details Column -->
            <ng-container matColumnDef="errorDetails" *ngIf="isColumnVisible('errorDetails')">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-left text-sm">Error Details</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-sm">{{element.errorDetails}}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions" *ngIf="isAdminOrSuperAdmin()">
              <th mat-header-cell *matHeaderCellDef
                class="bg-gray-50 font-semibold text-gray-900 px-4 py-3 text-center text-sm w-16">Actions</th>
              <td mat-cell *matCellDef="let element" class="px-4 py-3 text-center">
                <button (click)="togglePracticeMenu(element, $event)" class="p-1 hover:bg-gray-100 rounded">
                  <svg class="w-5 h-5 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z">
                    </path>
                  </svg>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="getLoadSummaryColumnNames()"></tr>
            <tr mat-row *matRowDef="let row; columns: getLoadSummaryColumnNames();"
              class="dashboard-load-summary-row"
              [class.load-summary-row-highlight]="shouldHighlightLoadSummaryRow(row)"></tr>
          </table>
        </div>

        <!-- Practice Actions Menu (outside table) -->
        <div *ngIf="practiceMenuOpen && selectedPractice"
          appClickOutsideDirective (appClickOutside)="practiceMenuOpen = false; selectedPractice = null"
          class="fixed bg-white border border-gray-200 rounded-sm shadow-lg z-[9999] w-48"
          [style.top.px]="menuPosition.top" [style.left.px]="menuPosition.left">
          <div class="py-1">
            <a *ngIf="selectedPractice.id !== null"
              (click)="navigateToLoadDetails(selectedPractice); practiceMenuOpen = false"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
              See Load Details
            </a>
            <a (click)="confirmAction(selectedPractice, 'StartOnDemandLoad')"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
              Start On-Demand Load
            </a>
            <a (click)="confirmAction(selectedPractice, 'RestartAgentService')"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
              Restart Agent Service
            </a>
            <a *ngIf="selectedPractice.id !== null && (selectedPractice.status==='ERROR - PMS BATCH' || selectedPractice.status==='COMPLETED - BASE' || selectedPractice.status==='COMPLETED - INPUT' || selectedPractice.status==='ERROR - SUBMIT JOB') && isAgentVersionGreaterOrEqual(selectedPractice.pmsAgentVersion, '14.0.0.0')"
              (click)="confirmAction(selectedPractice, 'ResubmitAWSBatchJob')"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
              Resubmit AWS Batch Job
            </a>
            <a *ngIf="selectedPractice.status !== 'LOAD DID NOT RUN'"
              (click)="confirmAction(selectedPractice, 'DeleteLoad')"
              class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer">
              Delete Load
            </a>
            <a (click)="confirmAction(selectedPractice, 'ResetInstallation')"
              class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer">
              Reset Installation
            </a>
          </div>
        </div>

        <!-- Confirmation Dialog -->
        <div *ngIf="showActionConfirmation"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            class="relative transform overflow-hidden bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z">
                    </path>
                  </svg>
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 class="text-base font-semibold leading-6 text-gray-900">Are you sure?</h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">{{confirmationMessage}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 gap-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button (click)="performConfirmedAction()" type="button"
                class="px-6 py-1.5 bg-indigo-500 text-gray-200 hover:bg-indigo-400 regular-font transition-colors duration-500 shadow-md focus:outline-none ring-offset-1 focus:ring-2">
                Confirm
              </button>
              <button (click)="cancelAction()" type="button"
                class="px-6 py-1.5 bg-gray-600 hover:bg-gray-500 text-gray-50 regular-font transition-colors duration-500 shadow-md focus:outline-none ring-offset-1 focus:ring-2 ring-gray-400">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-toast #toast></app-toast>
</section>
